export default __webpack_public_path__ + "static/img/banner.9d8d9f0.png";